import { Box, Text } from "@chakra-ui/react";
import {ReactComponent as Announcement} from '../svg/bullhorn.svg'
import {ReactComponent as Success} from '../svg/Success.svg'
import {ReactComponent as LevelUp} from '../svg/LevelUp.svg'
import {ReactComponent as Reminder} from '../svg/Reminder.svg'
import {ReactComponent as WarningIcon} from '../svg/WarningIcon.svg'
import IndividualActivityCard from "./IndividualActivityCard";
import { formatActivityDay, setAutocompleteVisibility } from "../redux/actions/action";
import { useDispatch } from "react-redux";

export default function Activities({activity}) {
    const dispatch = useDispatch()
    const iconMap = {
        A: {icon : Announcement, bgColor : "#FE676F", color:'#E54750'},
        S: {icon: Success, bgColor: "#47CCA5", color:'#47CCA5'},
        F: {icon: WarningIcon, bgColor: "#bec0bf", color:'#bec0bf'},
        L: {icon:LevelUp, bgColor : '#E83CE5', color:'#CF21CC'},
        E:{icon:Reminder, bgColor:'#F29131', color:'linear-gradient(90.57deg, rgba(242, 145, 49, 0.7) 3.35%, #F29131 94.78%)'}
    }

    return (
        <Box
            w='100%'
            d='flex'
            flexDir='column'
            mt = '1.5rem'
            onClick={(e) => {
                e.stopPropagation()
                dispatch(setAutocompleteVisibility(false))
            }}
        >

            <Text
                fontSize='14px'
                color='#222222'
                fontWeight='800'
                style={{ fontFamily: 'Mulish, sans-serif' }}
                textTransform = 'uppercase'
            >
                {formatActivityDay(activity.day)}
            </Text>

            <Box
                border='1px solid rgba(0, 0, 0, 0.1)'
                borderRadius='10px'
                boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                w='100%'
                bg='#ffffff'
                d='flex'
                flexDir='column'
                px='1rem'
                mt='1rem'
            >
                {
                    activity.activity.map((item, idx) => <IndividualActivityCard activity = {item} info = {iconMap[item.status]} />)
                }
            </Box>
        </Box>
    )
}